import '../Categories.css';
import { SettingsContentPanel } from 'pages/SettingsPage/components/SettingsContentPanel';
import { useClaimCategories } from './useClaimCategories';
import { AddFields, EntityTable, Panel } from 'components/UIComponents/EntityTable';
import {
  AwarePanel,
  EditFieldsList,
} from 'components/UIComponents/EntityTable/EntityTable.components';
import { ClaimCategoriesInput } from './ClaimCategoriesInput';
import { SectionType } from 'pages/ClaimsContractsToolPage/types';
import { AllClaimsCategories } from 'api/endpoints';
import { ApLoaderDefault } from '@alixpartners/ui-components';

const HEADERS = ['Major category name', 'Minor category name'];
const EDIT_HEADERS = [
  'Major category',
  'Minor category',
  'Category type',
  'Enabled/Disabled',
];

const COLUMN_KEYS: (keyof AllClaimsCategories)[] = [
  'majorCategoryId',
  'minorCategoryName',
];
const EDIT_COLUMN_KEYS: (keyof AllClaimsCategories)[] = [
  'majorCategoryName',
  'minorCategoryName',
  'categoryType',
  'enabled',
];

export const ClaimsCategories = () => {
  const {
    options,
    onAddSave,
    allCategories,
    warningMessage,
    onEditSave,
    handleToggleAll,
    toggleAll,
    fetching,
    sortState,
    handleSort,
    sortIcon,
    exportEnabledCategories,
  } = useClaimCategories();

  return (
    <SettingsContentPanel>
      <section className="categories">
        <EntityTable
          items={allCategories}
          addColumnKeys={COLUMN_KEYS}
          editColumnKeys={EDIT_COLUMN_KEYS}
          inputComponent={ClaimCategoriesInput}
          onEditSave={onEditSave}
          onAddSave={onAddSave}
          section={SectionType.Claims}
          options={options}
          toggleAll={toggleAll}
          handleToggleAll={handleToggleAll}
          sortState={sortState}
          handleSort={handleSort}
          sortIcon={sortIcon}
          handleExportItems={exportEnabledCategories}
        >
          <Panel title="Add Claims categories" className="add-category">
            <AddFields headers={HEADERS} />
          </Panel>
          <AwarePanel title="Claims Categories" className="edit-category">
            {fetching ? (
              <ApLoaderDefault loaderSize="lg" />
            ) : (
              <EditFieldsList
                headers={EDIT_HEADERS}
                warningMessage={warningMessage}
              />
            )}
          </AwarePanel>
        </EntityTable>
      </section>
    </SettingsContentPanel>
  );
};
